module.exports = __webpack_public_path__ + "static/rf-screenshot-discover-2-d9b2a58562cca74ec470cd7d7530269c.jpg";